import axios, { AxiosRequestConfig } from "axios";
import { API_BASE_URL } from "../../resources/constants";
import { getAccessToken, getUsername } from "../../utils/token-functions";

// Create an Axios instance without the initial token
export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor to add the token and username to headers and params
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = getAccessToken();
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    } else {
      console.warn("No access token found");
    }

    const username = getUsername();
    if (username) {
      config.params = {
        ...config.params,
        username,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
